import isEmpty from "lodash/isEmpty";
import kebabCase from "lodash/kebabCase";
import toUpper from "lodash/toUpper";
import moment from "moment";

const FieldsMapper = (data) => {
    const fields: any = [];

    Object.keys(data).forEach((fieldKey, fieldIndex) => {
        const field = {
            order: fieldIndex,
            label: fieldKey,
            name: toUpper(kebabCase(fieldKey)),
        };

        if (!fieldKey.includes("image") && fieldKey !== "videos") {
            field["value"] = data[fieldKey] ? data[fieldKey] : null;
            fields.push(field);
        } else if (fieldKey.includes("image")) {
            if (data[fieldKey]) {
                field["name"] = "File";
                field["value"] = data[fieldKey].keyObj;
                field["meta_data"] = {
                    featured: false,
                    description: "",
                    key: data[fieldKey].keyObj,
                    file_type: data[fieldKey].type,
                    file_name: data[fieldKey].name,
                    alt_text: data[fieldKey].altText,
                };
                fields.push(field);
            }
        }
    });

    return fields;
};

export const ComponentMapper = (data) => {
    const result = data.map((component, componentIndex) => {
        const componentData = {
            order: componentIndex,
            name: toUpper(kebabCase(component.type)),
            fields: FieldsMapper(component.fields),
        };

        return componentData;
    });

    return result;
};

export class ContentMapper {
    static map(content) {
        content.date = content.updated_at
            ? moment(content.updated_at).format("MMM DD, YYYY")
            : moment(content.created_at).format("MMM DD, YYYY");

        const overviewFields =
            !isEmpty(content.containers) &&
            !isEmpty(content.containers[0]) &&
            !isEmpty(
                content.containers[0].field_collections.filter((fc) => fc.name === "OVERVIEW")
            ) &&
            !isEmpty(
                content.containers[0].field_collections.filter((fc) => fc.name === "OVERVIEW")[0]
                    .fields
            ) &&
            content.containers[0].field_collections.filter((fc) => fc.name === "OVERVIEW")[0]
                .fields;

        content.imgURL =
            overviewFields &&
            !isEmpty(overviewFields.filter((field) => field.name === "Image")) &&
            overviewFields.filter((field) => field.name === "Image")[0].value &&
            overviewFields.filter((field) => field.name === "Image")[0].value;

        content.organization =
            overviewFields &&
            !isEmpty(overviewFields.filter((field) => field.name === "ORGANIZATION")) &&
            overviewFields.filter((field) => field.name === "ORGANIZATION")[0].value &&
            overviewFields.filter((field) => field.name === "ORGANIZATION")[0].value;

        content.year =
            overviewFields &&
            !isEmpty(overviewFields.filter((field) => field.name === "YEAR")) &&
            overviewFields.filter((field) => field.name === "YEAR")[0].value &&
            overviewFields.filter((field) => field.name === "YEAR")[0].value;

        content.award =
            overviewFields &&
            !isEmpty(overviewFields.filter((field) => field.name === "AWARD")) &&
            overviewFields.filter((field) => field.name === "AWARD")[0].value &&
            overviewFields.filter((field) => field.name === "AWARD")[0].value;

        delete content.containers;
        delete content.__typename;

        return content;
    }
}
